import $ from 'jquery';
import slick from 'slick-carousel';
import lightbox from 'slick-lightbox';


export default () => {
    if ($("#galleria").length > 0) {
        $('#galleria').slick({
            autoplay: false,
            dots: false,
            arrows: true,
            prevArrow : $('.navigator-arrow.arrow-left .icon-arrow-left'),
            nextArrow : $('.navigator-arrow.arrow-right .icon-arrow-right'),
            adaptiveHeight: true,
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                    },
                },
            ],
        }).slickLightbox({
            src: 'src',
            itemSelector: 'a img'
        });
    }
};



// WEBPACK FOOTER //
// ./scripts/libs/slick.js